module.exports = __webpack_public_path__ + "static/img/detailDw.8df03f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailDw.jpg
// module id = QtKL
// module chunks = 7